import React from 'react';
import {
  useDispatch, useSelector
} from 'react-redux';
import { useQuery } from '@apollo/client';

import {
  ADMIN, ALL_BUSINESS_ID_LIST
} from '../../data/BusinessConstants';
import {
  getRFXUserBusinessQuery,
  GetUserBusinessQueryResultType
} from '../../gql/queries/getRFXUserBusinessQuery';
import {
  NullableString, NullableStringArray
} from '../../interfaces';
import { RootState } from '../../store';
import { getWorkflowForBusinessIds } from '../../util/WorkflowUtils';
import { selectRFXUserBusiness, setCurrentWorkflow, setRFXUserBusiness } from '../reducers/businessSlice';
import { isExternalArgoUser } from '../RFX/userPermissionHelper';

export interface UseUserBusinessResultType {
  isExternalUser: boolean;
  userBusiness: NullableStringArray;
  loading: boolean;
  error: NullableString;
}

/**
 * Custom hook to get user's businessId list
 */
export function useUserBusiness(): UseUserBusinessResultType {
  const isExternalUser = isExternalArgoUser();
  const dispatch = useDispatch();

  const userBusiness = useSelector((state: RootState) => {
    return selectRFXUserBusiness(state);
  });

  const skip: boolean = isExternalUser || userBusiness !== null;

  const { data, error, loading } = useQuery<GetUserBusinessQueryResultType>(getRFXUserBusinessQuery,
    { fetchPolicy: "cache-first", skip: skip });
  console.log({ isExternalUser, userBusiness });
  console.log({ data, error, loading });

  if (isExternalUser) {
    return {
      isExternalUser,
      userBusiness: null,
      loading: false,
      error: null
    };
  }

  if (userBusiness !== null) {
    return {
      isExternalUser,
      userBusiness,
      loading: false,
      error: null
    };
  }

  let userBusinessResult: NullableStringArray = null;

  if (data) {
    console.log({ data });
    userBusinessResult = data.getRFXUserBusiness.businessIdList;
    if (userBusinessResult?.includes(ADMIN)) {
      userBusinessResult = [...ALL_BUSINESS_ID_LIST];
    }

    const currentWorkflow = getWorkflowForBusinessIds(userBusinessResult);
    dispatch(setRFXUserBusiness(userBusinessResult));
    dispatch(setCurrentWorkflow(currentWorkflow));
  }

  return { isExternalUser, userBusiness: userBusinessResult, error: error?.message || null, loading };
}
